// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { Office_abstract } from './../abstract/SagaSchema/Office_abstract';
export class Office extends Office_abstract {}
